import { useTranslation } from 'react-i18next';
import { UserService } from '../services/User.service';
import { makeListQueryKey } from './utils/user';
import { useMutation } from '@shared/lib/hooks';
import { ToastService } from '@shared/lib/services/toast.service';
export function useInviteUser() {
    const projectId = process.env.CUSTOMER_PROJECT_ID;
    const { t } = useTranslation();
    const listQueryOptions = { queryKey: makeListQueryKey(projectId) };
    const { mutate: inviteUser, isLoading: isInviting, isSuccess: isInvited } = useMutation({
        mutationFn: email => UserService.inviteUser(projectId, email).catch(() => {
            const errorMessage = t('Error occurred. Please try to send new invitation.');
            ToastService.error(errorMessage);
            throw new Error(errorMessage);
        }),
        options: listQueryOptions
    });
    return {
        inviteUser,
        isInviting,
        isInvited
    };
}
